module.exports = __webpack_public_path__ + "img/img8.824a8b83.png";